import React from 'react';
import RestaurantsState from './restaurantsState/RestaurantsState';
import RestaurantsControlPanel from './components/RestaurantsControlPanel/RestaurantsControlPanel';
import { ModalWindows } from './components/ModalWindows';
import Restaurants from './components/Restaurants/Restaurants';
import RestaurantFullInfoPage from '../RestaurantFullInfo';
import style from './index.module.scss';

const RestaurantsPage: React.FC = () => {
	return (
		<RestaurantsState>
			<div className={style.container} data-test="RestaurantsPage">
				<RestaurantsControlPanel />
				<Restaurants />
				<ModalWindows />
				<RestaurantFullInfoPage />
			</div>
		</RestaurantsState>
	);
};

export default RestaurantsPage;
